import { LogoContainer, TeamSelector, TeamSelectorContent } from "./styles";
import { selectRosterDisplayName } from "selectors/Roster";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  rosterId: string | undefined;
  tournamentId: string;
  selectedRosterId: string | undefined;
  disableSelection: boolean;
  updateSelectedRoster: (rosterId: string | undefined) => void;
}

export const BracketPickerMatchTeam = ({
  rosterId,
  tournamentId,
  selectedRosterId,
  disableSelection,
  updateSelectedRoster,
}: Props) => {
  const displayName = useAppSelector((state) =>
    !!rosterId
      ? selectRosterDisplayName(state, rosterId, tournamentId)
      : undefined
  );

  return (
    <TeamSelector
      key={rosterId}
      selected={!!selectedRosterId && selectedRosterId === rosterId}
      disabled={disableSelection}
      onClick={() => updateSelectedRoster(rosterId)}
    >
      <TeamSelectorContent disabled={disableSelection}>
        <LogoContainer>
          {!!rosterId && (
            <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
          )}
        </LogoContainer>
        {displayName ?? ""}
      </TeamSelectorContent>
    </TeamSelector>
  );
};
